import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import Icon from "./icon";
import Button from "../elements/button";

export default class EmptyStateMessage extends React.Component {
  static displayName = "EmptyStateMessage";

  static propTypes = {
    icon: PropTypes.string,
    iconKit: PropTypes.string,
    text: PropTypes.node,
    subtext: PropTypes.node,
    size: PropTypes.oneOf(["small", "default", "page"]),
    actionLabel: PropTypes.any,
    actionLink: PropTypes.any,
    onAction: PropTypes.func,
    actionButton: PropTypes.any,
  };

  static defaultProps = {
    icon: "search",
    iconKit: "gt",
    size: "default",
  };

  render() {
    return (
      <div className={classNames("et--empty-state-message", this.props.className, `is-${this.props.size}`)}>
        <Icon className="et--empty-state-message--icon" icon={this.props.icon} iconKit={this.props.iconKit} />
        {this.props.text ? <div className="et--empty-state-message--text">{this.props.text}</div> : undefined}
        {this.props.subtext ? <div className="et--empty-state-message--subtext">{this.props.subtext}</div> : undefined}
        <div className="et--empty-state-message--content">{this.props.children}</div>

        <div className="et--empty-state-message--action-area" style={{ display: "flex", justifyContent: "center" }}>
          <div>
            {this.props.actionLabel ? (
              <div>
                {(() => {
                  if (this.props.onAction) {
                    return (
                      <Button type="secondary" onClick={this.props.onAction}>
                        {this.props.actionLabel}
                      </Button>
                    );
                  } else if (this.props.actionLink) {
                    return (
                      <a className="et--empty-state-message--action-button btn" href={this.props.actionLink}>
                        {this.props.actionLabel}
                      </a>
                    );
                  }
                })()}
              </div>
            ) : undefined}
          </div>
          <div style={{ marginLeft: "20px" }}>{this.props.actionButton ? this.props.actionButton : undefined}</div>
        </div>
      </div>
    );
  }
}
